import PropTypes from 'prop-types';
import React, { lazy } from 'react';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const layout = window?.$environment?.CURRENT_LAYOUT;
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
const Checkbox = lazy(() => import(`globalcomponents/UI/Checkbox/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));

const CategoryItem = ({
  categoryItem,
  i18n,
  changeInspectionEnabled,
  handleDeleteItem,
  index
}) => {

  return (
    <>
      <FormStyle.default.FieldsWrapper width="100%" className="partdetails">
        <Label variant="body1">{categoryItem.vehicleSectionName}</Label>
        <FormStyle.default.CheckBoxWrapper
          direction="row"
          className="roleWrapper"
        >
          <Checkbox
            type="NormalGrey"
            defaultValue
            checked={categoryItem.inspectionEnabled}
            onClick={(event) => {
              changeInspectionEnabled(categoryItem, index, event);
            }}
          />
          <Icon
            src={mediaUrls?.deleteIcon}
            onClick={() => handleDeleteItem(categoryItem, index)}
          />
        </FormStyle.default.CheckBoxWrapper>
      </FormStyle.default.FieldsWrapper>
    </>
  );
};
export default CategoryItem;

CategoryItem.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  fetchAdvancedConfig: PropTypes.func.isRequired,
  advancedConfig: PropTypes.object.isRequired
};
